import { useFilterDisabledSettings } from "@api";
import { UrlInput } from "@inputs/url";
import InfoIcon from "@mui/icons-material/Info";
import { FormControlLabel, Radio, RadioGroup, Stack, Tooltip, Typography } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { StackGrid } from "@styleguide";
import { AddressInput } from "../components/address";
import { AppellationInput } from "../components/appellations";
import { ContractInput } from "../components/contract";
import { ContractDurationInput } from "../components/contractDuration";
import { DateInput } from "../components/date";
import { OfferCreateInput } from "../components/offerCreate";
import { PermanentInput } from "../components/permanent";
import { WeeklyDurationInput } from "../components/weeklyDuration";
import { useModalOfferContext } from "../context";
import { classes } from "../styles";

export const DetailsSection = () => {
  const { settings } = useGlobalContext();
  const {
    offer,
    setOffer,
    createOffer,
    errors,
    setErrors,
    searchUrlDone,
    setSearchUrlDone,
    getOfferUrl,
    cancelGetOfferUrl,
    loadingUrl,
  } = useModalOfferContext();

  const settingsOfferOrigin = useFilterDisabledSettings(settings?.settingsOfferOrigin, offer.externalSource).filter(
    (option) => option.value !== "provenance_contact_entreprise"
  );

  return (
    <>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography variant="subtitle2SemiBold" color="primary">
          Détails du poste
        </Typography>
        <Tooltip title="Tapez le poste occupé, une appellation correspondante sera automatiquement détectée. N'hésitez pas à modifier cette suggestion si elle ne vous convient pas, cela participera à améliorer les suivantes.">
          <InfoIcon fontSize="small" color="primary" />
        </Tooltip>
      </Stack>

      <OfferCreateInput />
      {createOffer && (
        <UrlInput
          url={offer.url ?? ""}
          onUrlChange={(url) => {
            setOffer((offer) => ({ ...offer, url }));
            if (!url) {
              setSearchUrlDone(false);
            }
          }}
          onSearch={getOfferUrl}
          onCancelSearch={cancelGetOfferUrl}
          loading={loadingUrl}
          searchDone={searchUrlDone}
          found={Boolean(offer.offerId)}
        />
      )}

      <StackGrid perLine={2} gap={2}>
        <AppellationInput className={classes.fullWidth} />
      </StackGrid>
      <AddressInput />

      <StackGrid perLine={2} gap={2}>
        <ContractInput />
        {offer.contractType && !offer.contractType.includes("cdi") && <ContractDurationInput />}
      </StackGrid>

      {createOffer && (
        <StackGrid perLine={2} gap={2}>
          <DateInput field="startDate" />
          <DateInput field="expirationDate" />
        </StackGrid>
      )}

      {createOffer && <PermanentInput />}

      <StackGrid perLine={2} gap={2}>
        <WeeklyDurationInput />
      </StackGrid>

      <Stack gap={1} direction="row" alignItems="center" flexWrap="wrap">
        <Typography variant="body1" color={errors.externalSource ? "error.main" : "text.primary"}>
          Qui a trouvé l&apos;offre : *
        </Typography>
        <RadioGroup
          row
          value={offer.externalSource ?? ""}
          onChange={(event) => {
            setOffer((offer) => ({ ...offer, externalSource: event.target.value }));
            setErrors((errors) => ({ ...errors, externalSource: false }));
          }}
        >
          {settingsOfferOrigin.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio size="small" />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </Stack>
    </>
  );
};
